import * as actions from "../../../actions/financial/dailyRevenue";

const initialState = {
  loading: false,
  items: []
};

const reducer = function(state = initialState, { type, payload }) {
  switch (type) {
    case actions.GET_DAILYREVENUE: {
      return {
        ...state,
        loading: true
      };
    }
    case actions.GET_DAILYREVENUE_SUCCESS: {
      return {
        ...state,
        items: payload ? payload : [],
        loading: false
      };
    }
    case actions.GET_DAILYREVENUE_ERROR: {
      return {
        ...state,
        loading: false
      };
    }
    case actions.CLEAR_ITEMS: {
      return {
        ...state,
        items: []
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
